import { debounce, breakpoint } from '../../util/helpers';
import { setElementInert } from '../../util/a11y/handle-inert';

export default {
  init() {
    const customersMiniList = document.querySelector('.ms-customers-mini-list');
    
    if (customersMiniList) {
      if (breakpoint() === 'mobile') {
        customersMiniList.style.height = '230px';
      }

      this.startListener(customersMiniList);
    }
  },
  startListener(customersMiniList) {
    const toggleButton = customersMiniList.querySelector('.ms-customers-mini-list__mobile-toggle');
    const miniListContent = customersMiniList.querySelector('.ms-customers-mini-list__content');

    setElementInert(false, miniListContent);

    toggleButton.addEventListener('click', () => {
      customersMiniList.classList.toggle('active');

      if (customersMiniList.classList.contains('active')) {
        toggleButton.setAttribute('aria-expanded', true);
        setElementInert(false, miniListContent);

        setTimeout(() => {
          customersMiniList.style.height = '';
        }, 200);
      }
      else {
        customersMiniList.style.height = '230px';

        toggleButton.setAttribute('aria-expanded', false);
        setElementInert(true, miniListContent);
      }
    });

    /* Handle inert */
    const handleResize = debounce(() => {
      if (breakpoint() === 'mobile') {
        if (customersMiniList.classList.contains('active')) {
          customersMiniList.classList.remove('active');
          customersMiniList.style.height = '230px';

          toggleButton.setAttribute('aria-expanded', false);
          setElementInert(true, miniListContent);
        }
      }
      else {
        customersMiniList.classList.remove('active');

        customersMiniList.style.height = '';
        toggleButton.setAttribute('aria-expanded', false);
        setElementInert(false, miniListContent);
      }
    }, 100);

    /* Initiate functions on resize */
    window.addEventListener('resize', handleResize);
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/customers-mini-list.js